import { connect } from 'react-redux';

import { IState } from '../../store/index';
import { DemolishedInMoscowProgramm, IDemolishedInMoscowProgrammProps } from './index';

function mapStateToProps(state: IState): IDemolishedInMoscowProgrammProps {
  return {
    demolishedInMoscowProgramm: state.offerData.offer.demolishedInMoscowProgramm,
  };
}

export const DemolishedInMoscowProgrammContainer = connect<IDemolishedInMoscowProgrammProps, {}, {}>(mapStateToProps)(
  DemolishedInMoscowProgramm,
);
